import React from "react";

const LoginNavHeader = () => {
  return (
    <section className="text-center  px-6 md:px-0 bg-[#6E3FC6] text-white py-16  shadow-lg">

      <h1 className="text-3xl md:text-3xl leading-snug">
       Login Component<br />
        <span >restaurant and retail</span>
      </h1>
      <p className="mt-6 text-sm md:text-base text-[#e0dfff] font-normal">
        we simplify the way you do restaurant and retail business
      </p>
    </section>
  );
};

export default LoginNavHeader;